import { render, staticRenderFns } from "./DropdownContent.vue?vue&type=template&id=b83c9bc2&"
import script from "./DropdownContent.vue?vue&type=script&lang=js&"
export * from "./DropdownContent.vue?vue&type=script&lang=js&"
import style0 from "./DropdownContent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports